import type { Guest } from '@mathflat/domain/@entities/Guest/type'

import { Student } from './Student'

/** creverseStdId 를 보존하는 Guest 전용 Student. 공용 Student DTO(StudentController 미러)에 guest 전용 식별자를 섞지 않으려 분리. */
export class GuestStudent extends Student {
  creverseStdId: Guest['creverseStdId'] = ''

  constructor({
    creverseStdId,
    ...studentData
  }: ConstructorParameters<typeof Student>[0] & { creverseStdId: Guest['creverseStdId'] }) {
    super(studentData)
    this.creverseStdId = creverseStdId
  }
}
